const Calender = () => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.91667 17.3333C1.45833 17.3333 1.06597 17.1701 0.739583 16.8437C0.413194 16.5173 0.25 16.125 0.25 15.6666V3.99996C0.25 3.54163 0.413194 3.14927 0.739583 2.82288C1.06597 2.49649 1.45833 2.33329 1.91667 2.33329H2.75V0.666626H4.41667V2.33329H11.0833V0.666626H12.75V2.33329H13.5833C14.0417 2.33329 14.434 2.49649 14.7604 2.82288C15.0868 3.14927 15.25 3.54163 15.25 3.99996V15.6666C15.25 16.125 15.0868 16.5173 14.7604 16.8437C14.434 17.1701 14.0417 17.3333 13.5833 17.3333H1.91667ZM1.91667 15.6666H13.5833V7.33329H1.91667V15.6666ZM1.91667 5.66663H13.5833V3.99996H1.91667V5.66663Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default Calender;
